import { Component } from 'react';
import PropTypes from 'prop-types';

/** It is not a pure function component so it can be extended by specialized components like
 * PageActionBar.Actions, PageActionBar.Header, etc... */
class RenderChildren extends Component {
  static propTypes = {
    children: PropTypes.node,
  };

  static defaultProps = {
    children: null,
  };

  render() {
    return this.props.children;
  }
}

export default RenderChildren;
